import { SVGProps } from 'react';

const CornerUpRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m15 4 5 5-5 5m5-5H8a4 4 0 0 0-4 4v7"
    />
  </svg>
);
export default CornerUpRight;
